import { DCM_TAG_RENDERED } from './constants';

/*
  Mark campaign's dcm preview tag as rendered in Redux
*/
export function setDcmPreviewTagRendered(campaignId) {
  return (dispatch, getState) => {
    if (!campaignId)
      throw new Error('Must provide campaignId to mark preview dcm tag as rendered.');

    dispatch({
      type: DCM_TAG_RENDERED,
      payload: campaignId
    });
  }
}



// WEBPACK FOOTER //
// ./src/redux/dcm/actions.js